<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="93" height="86.232" viewBox="0 0 93 86.232">
		<g transform="translate(1.87 1.38)">
			<path
				id=""
				d="M19.513,34.966A16.923,16.923,0,1,0,2.59,18.043,16.923,16.923,0,0,0,19.513,34.966Z"
				transform="translate(11.579 0)"
				fill="none"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="5"
			/>
			<path
				id=""
				d="M.63,41.855H61.553v-3.67A30.529,30.529,0,0,0,32.47,8.009q-.69-.033-1.378-.034t-1.377.034A30.53,30.53,0,0,0,.63,38.185Z"
				transform="translate(0 40.496)"
				fill="none"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="5"
			/>
			<path
				id=""
				d="M8.96,34.966a16.923,16.923,0,1,0,0-33.846"
				transform="translate(49.209 0)"
				fill="none"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="5"
			/>
			<path
				id=""
				d="M20.094,41.193H33.632V37.523A30.529,30.529,0,0,0,9.94,8.087"
				transform="translate(54.998 41.159)"
				fill="none"
				:stroke="color"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="5"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'GroupIcon',
	props: {
		color: {
			type: String,
			default: 'var(--el-color-primary)',
		},
	},
};
</script>
